(function () {
  'use strict';

  var MAX_MB = 20; // per-file cap; Apps Script chokes on huge base64 payloads

  function init() {
    var root = document.querySelector('[data-capset-upload]');
    if (!root) return;

    var driveUrl     = root.getAttribute('data-drive-url') || '';
    var driveFolder  = root.getAttribute('data-folder') || 'UV Files';
    var productTitle = (root.getAttribute('data-product-title') || '').trim();

    var variantMap = {};
    try { variantMap = JSON.parse(root.getAttribute('data-variants') || '{}'); } catch (e) {}

    var form    = root.closest('form') || document.querySelector('.product-single__form');
    var modeWrap = root.querySelector('[data-capset-mode]');
    var errorEl  = root.querySelector('[data-capset-error]');

    // ── Build one state object per slot ──────────────────────────────────
    var slots = Array.prototype.slice.call(root.querySelectorAll('[data-capset-slot]')).map(function (el) {
      var slot = {
        key:      el.getAttribute('data-capset-slot'),      // both | body | rear
        prop:     el.getAttribute('data-prop'),             // cart property name
        el:       el,
        input:    el.querySelector('[data-capset-input]'),
        dropBtn:  el.querySelector('[data-capset-drop]'),
        listEl:   el.querySelector('[data-capset-list]'),
        links:    [],   // ["logo.svg: https://drive…", …]
        pending:  [],   // in-flight upload promises
        hidden:   null  // the properties[…] input on the form
      };

      // A disabled hidden input per slot; enabled only while the slot is active
      // so inactive caps never send a stale graphic property.
      if (form) {
        var h = document.createElement('input');
        h.type = 'hidden';
        h.name = 'properties[' + slot.prop + ']';
        h.disabled = true;
        form.appendChild(h);
        slot.hidden = h;
      }
      return slot;
    });

    function slotByKey(key) {
      for (var i = 0; i < slots.length; i++) { if (slots[i].key === key) return slots[i]; }
      return null;
    }

    // ── Which slots apply to the current variant + mode ──────────────────
    var currentKind = 'pair';
    var currentMode = 'same';

    function activeKeys() {
      if (currentKind === 'body') return ['body'];
      if (currentKind === 'rear') return ['rear'];
      if (currentKind === 'pair' && currentMode === 'different') return ['body', 'rear'];
      return ['both']; // pair + same
    }

    function activeSlots() {
      var keys = activeKeys();
      return slots.filter(function (s) { return keys.indexOf(s.key) !== -1; });
    }

    function render() {
      if (modeWrap) modeWrap.hidden = currentKind !== 'pair';
      var keys = activeKeys();
      slots.forEach(function (s) {
        var on = keys.indexOf(s.key) !== -1;
        s.el.hidden = !on;
        if (s.hidden) s.hidden.disabled = !on;
        if (!on) s.el.classList.remove('is-invalid');
      });
      showError(false);
    }

    function setVariant(id) {
      var kind = variantMap[String(id)];
      if (kind) { currentKind = kind; render(); }
    }

    function syncSlot(slot) {
      if (slot.hidden) slot.hidden.value = slot.links.join('   |   ');
    }

    function showError(show, missing) {
      if (errorEl) errorEl.hidden = !show;
      slots.forEach(function (s) { s.el.classList.remove('is-invalid'); });
      if (show) {
        (missing || activeSlots()).forEach(function (s) {
          if (!s.links.length) s.el.classList.add('is-invalid');
        });
        root.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    // ── File rows + uploading ────────────────────────────────────────────
    function renderRow(slot, name) {
      var row = document.createElement('div');
      row.className = 'capset-upload__file';
      var nameEl = document.createElement('span');
      nameEl.className = 'capset-upload__file-name';
      nameEl.textContent = name;
      var statusEl = document.createElement('span');
      statusEl.className = 'capset-upload__file-status';
      statusEl.textContent = 'Uploading…';
      var removeEl = document.createElement('button');
      removeEl.type = 'button';
      removeEl.className = 'capset-upload__file-remove';
      removeEl.setAttribute('aria-label', 'Remove file');
      removeEl.innerHTML = '&times;';
      row.appendChild(nameEl);
      row.appendChild(statusEl);
      row.appendChild(removeEl);
      if (slot.listEl) slot.listEl.appendChild(row);
      return {
        setDone: function (link) {
          row.classList.add('is-done');
          statusEl.textContent = 'Uploaded ✓';
          if (link) slot.links.push(link);
          syncSlot(slot);
          showError(false);
          removeEl.addEventListener('click', function () {
            if (link) slot.links = slot.links.filter(function (l) { return l !== link; });
            syncSlot(slot);
            row.remove();
          });
        },
        setError: function (msg) {
          row.classList.add('is-error');
          statusEl.textContent = msg || 'Upload failed — try again';
          removeEl.addEventListener('click', function () { row.remove(); });
        }
      };
    }

    function readAsPayload(slot, file) {
      return new Promise(function (resolve) {
        var reader = new FileReader();
        reader.onload = function (ev) {
          var base64 = ev.target.result.split(',')[1];
          // Self-describing name in Drive: product + which cap + original name.
          var capTag = slot.key === 'body' ? 'Body cap'
                     : slot.key === 'rear' ? 'Rear cap'
                     : 'Both caps';
          var savedName = (productTitle ? productTitle + ' – ' : '') + capTag + ' – ' + file.name;
          resolve({ filename: savedName, mimeType: file.type || 'application/octet-stream', data: base64 });
        };
        reader.readAsDataURL(file);
      });
    }

    function uploadFiles(slot, fileList) {
      if (!driveUrl) return;
      Array.prototype.slice.call(fileList).forEach(function (file) {
        var row = renderRow(slot, file.name);
        if (file.size > MAX_MB * 1024 * 1024) {
          row.setError('Too large — max ' + MAX_MB + 'MB');
          return;
        }
        var p = readAsPayload(slot, file)
          .then(function (payload) {
            return fetch(driveUrl, {
              method: 'POST',
              body: JSON.stringify({ files: [payload], folder: driveFolder }),
              redirect: 'follow',
              headers: { 'Content-Type': 'text/plain' }
            });
          })
          .then(function (res) { return res.json(); })
          .then(function (result) {
            if (result && result.success && result.files && result.files.length) {
              var f = result.files[0];
              row.setDone(f.filename + ': ' + f.url);
            } else {
              row.setError();
            }
          })
          .catch(function () { row.setError(); });
        slot.pending.push(p);
      });
    }

    // ── Wire each slot's drop zone ───────────────────────────────────────
    slots.forEach(function (slot) {
      if (slot.dropBtn) slot.dropBtn.addEventListener('click', function () { slot.input.click(); });
      if (slot.input) {
        slot.input.addEventListener('change', function () {
          uploadFiles(slot, slot.input.files);
          slot.input.value = '';
        });
      }
      ['dragenter', 'dragover'].forEach(function (ev) {
        slot.el.addEventListener(ev, function (e) { e.preventDefault(); slot.el.classList.add('is-drag'); });
      });
      ['dragleave', 'drop'].forEach(function (ev) {
        slot.el.addEventListener(ev, function (e) { e.preventDefault(); slot.el.classList.remove('is-drag'); });
      });
      slot.el.addEventListener('drop', function (e) {
        if (e.dataTransfer && e.dataTransfer.files) uploadFiles(slot, e.dataTransfer.files);
      });
    });

    // ── Pair mode toggle ─────────────────────────────────────────────────
    if (modeWrap) {
      modeWrap.addEventListener('change', function (e) {
        if (e.target && e.target.name === 'capset-mode') {
          currentMode = e.target.value === 'different' ? 'different' : 'same';
          render();
        }
      });
    }

    // ── Track the selected variant ───────────────────────────────────────
    document.addEventListener('variant:change', function (e) {
      if (e.detail && e.detail.variant && e.detail.variant.id) setVariant(e.detail.variant.id);
    });
    // Initial variant: whatever the form's master select currently holds.
    var master = form && form.querySelector('[name="id"]');
    if (master && variantMap[String(master.value)]) {
      setVariant(master.value);
    } else {
      render();
    }

    // ── Gate add-to-cart until the active slot(s) have a graphic ──────────
    if (form) {
      var resubmitting = false;
      form.addEventListener('submit', function (e) {
        if (resubmitting) { resubmitting = false; return; }

        var active = activeSlots();
        var missing = active.filter(function (s) { return !s.links.length; });
        if (!missing.length) return; // every active cap has a graphic — proceed

        // Some active slot still uploading: hold the submit until it settles.
        var pending = [];
        active.forEach(function (s) { pending = pending.concat(s.pending); });
        if (pending.length) {
          e.preventDefault();
          e.stopImmediatePropagation();
          var btn = form.querySelector('[data-add-to-cart]');
          if (btn) btn.classList.add('btn--loading');
          Promise.all(pending.map(function (p) { return p.catch(function () {}); }))
            .then(function () {
              if (btn) btn.classList.remove('btn--loading');
              var stillMissing = activeSlots().filter(function (s) { return !s.links.length; });
              if (!stillMissing.length) {
                resubmitting = true;
                if (form.requestSubmit) form.requestSubmit();
                else form.submit();
              } else {
                showError(true, stillMissing);
              }
            });
          return;
        }

        // Nothing uploaded for a required cap: block and point at it.
        e.preventDefault();
        e.stopImmediatePropagation();
        showError(true, missing);
      }, true); // capture phase — runs before the theme's own handler
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
